import { Img } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = { src: string; alt: string };

const ImageComponent: FC<Props> = ({ src, alt }) => (
  <Img
    src={src}
    alt={alt}
    width={210}
    height={282}
    dpr={1.5}
    fit="crop"
    crop="faces"
    quality={100}
  />
);

export default ImageComponent;
